import { Form, type FormInstance } from 'antd';
import { useCallback } from 'react';
import type { MaxLessonsPerDay, MaxLessonsPerDayConfigurationItem } from 'shared/api';
import { getColumns } from './columns';

export const useMaxLessonsPerDayForm = (
  form: FormInstance<MaxLessonsPerDay>,
  readOnly?: boolean,
) => {
  const parameters: MaxLessonsPerDayConfigurationItem[] = Form.useWatch('parameters', form) ?? [];

  const onValueChange = useCallback(
    (index: number, value: number | null) => {
      const currentValues =
        (form.getFieldValue('parameters') as MaxLessonsPerDayConfigurationItem[]) ?? [];
      const updated = [...currentValues];
      updated[index] = {
        ...updated[index],
        maxLessonsPerDay: value ?? undefined,
      };
      form.setFieldsValue({ parameters: updated });
      form.validateFields(['parameters']);
    },
    [form],
  );

  const columns = getColumns(readOnly, onValueChange);

  return {
    state: {
      parameters,
      columns,
    },
    methods: {},
  };
};
